module.exports = __webpack_public_path__ + "static/media/ventilador.a616a4b0.svg";